function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { Button } from '../../Button';
const Container = styled.div.withConfig({
  componentId: "aui__sc-15shsec-0"
})(["box-sizing:border-box;width:100%;padding:16px;"]);
const Row = styled(Container).withConfig({
  componentId: "aui__sc-15shsec-1"
})(["display:flex;flex-direction:row;"]);
const Column = styled(Container).withConfig({
  componentId: "aui__sc-15shsec-2"
})(["display:flex;flex-direction:column;"]);
const fillParent = {
  flex: 1
};
const rightSpacer = {
  marginRight: '10px'
};
const bottomSpacer = {
  marginBottom: '10px'
};
export const DrawerFooter = ({
  view,
  primaryButton,
  secondaryButton
}) => {
  switch (view) {
    case 'one':
      return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Button, _extends({}, primaryButton, {
        style: {
          width: '100%'
        }
      })));
    case 'two':
      return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Button, _extends({}, primaryButton, {
        style: {
          ...fillParent,
          ...rightSpacer
        }
      })), /*#__PURE__*/React.createElement(Button, _extends({
        variant: 'outline'
      }, secondaryButton, {
        style: fillParent
      })));
    case 'one-above-one':
      return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Button, _extends({}, primaryButton, {
        style: {
          ...fillParent,
          ...bottomSpacer
        }
      })), /*#__PURE__*/React.createElement(Button, _extends({
        variant: 'flat'
      }, secondaryButton, {
        style: fillParent
      })));
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};